import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom"; 
import ReactGA from "react-ga4";

// Components
import Navbar from "./landing_page/Navbar";
import MultiLocationSearch from "./landing_page/MultiLocationSearch";
import HomePage from "./HomePage";
import Footer from "./landing_page/Footer";
import Blueprint from "./pages/Blueprint";
import WhatsappWidget from "./Components/WhatsappWidget";
import Contact from "./pages/Contact";
import About from "./pages/About";
import LeadCaptureModal from "./sections/LeadCaptureModal";
import Package from "./pages/Package";
import Blog from "./pages/Blog";
import usePageTracking from "./pages/usePageTracking";

// 🔐 Initialize Google Analytics 4
ReactGA.initialize("G-6YQ41WYR5E"); // 

function App() {
  const [leadSubmitted, setLeadSubmitted] = useState(() => {
    return !!localStorage.getItem("leadUser");
  });

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const hasSubmitted = localStorage.getItem("leadUser");
    if (!hasSubmitted) {
      const timer = setTimeout(() => setShowModal(true), 2500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleLeadSubmit = () => {
    localStorage.setItem("leadUser", "true");
    setLeadSubmitted(true);
    setShowModal(false);
  };

  // 📊 Track pageviews on route change
  usePageTracking();

  return (
    
      <>
        {/* Watermark in background */}
        <div style={styles.watermark}>Kismat Ki Property</div>

        {/* Lead Capture Modal */}
        {!leadSubmitted && showModal && (
          <LeadCaptureModal onSubmit={handleLeadSubmit} />
        )}

        {/* Navbar */}
        <Navbar />

        {/* Location Search */}
        <MultiLocationSearch />

        {/* WhatsApp Widget */}
        <WhatsappWidget />

        {/* Page Routes */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blueprint" element={<Blueprint />} />
          <Route path="/package" element={<Package />} />
          <Route path="/blog" element={<Blog />} />
        </Routes>

        {/* Footer */}
        <Footer />

        {/* Floating watermark animation */}
        <style>{`
          @keyframes floatText {
            0% { transform: translate(-50%, -50%) rotate(-30deg); }
            50% { transform: translate(-50%, -52%) rotate(-30deg); }
            100% { transform: translate(-50%, -50%) rotate(-30deg); }
          }
        `}</style>
      </>
  );
}

const styles = {
  watermark: {
    position: "fixed",
    top: "50%",
    left: "50%",
    fontSize: "5rem",
    fontWeight: "bold",
    color: "rgba(0, 0, 0, 0.03)",
    transform: "translate(-50%, -50%) rotate(-30deg)",
    pointerEvents: "none",
    whiteSpace: "nowrap",
    zIndex: 0,
    animation: "floatText 6s ease-in-out infinite",
  },
};

export default App;
